<template>
    <div>
        <career/>
        <div class="row">
            <div class="col-lg-9">
                <timeline/>
            </div>
            <div class="col-lg-3">
                <skills/>
                <languages/>
                <hobbies/>
            </div>
        </div>
    </div>
</template>

<script>
    import Hobbies from "./../sections/Hobbies";
    import Languages from "./../sections/Languages";
    import Skills from "./../sections/Skills";
    import Career from "./../sections/Career";
    import Timeline from "./../sections/Timeline";

    export default {
        name: 'Home',
        components: {
            Timeline,
            Career,
            Skills,
            Languages,
            Hobbies
        },
    }
</script>